import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["uiProps", "overrideProps", "showHidden"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useContext } from "react";
import PropTypes from "prop-types";
import { ComponentMapContext } from "../componentMap/ComponentMapProvider";
import { renderContentFromMetadataInternal } from "../render/renderMetadataHelper";
var metadataContentPropTypes = {
  uiProps: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.array]).isRequired,
  overrideProps: PropTypes.objectOf(PropTypes.any),
  resolveValidation: PropTypes.func,
  resolveFormValidation: PropTypes.func,
  resolveDataProps: PropTypes.func,
  resolveValue: PropTypes.func,
  resolveComponentMap: PropTypes.objectOf(PropTypes.any),
  resolveClassNameMap: PropTypes.objectOf(PropTypes.any),
  resolveCallbackMap: PropTypes.objectOf(PropTypes.any),
  showHidden: PropTypes.bool
};
export var MetadataContent = function (_ref) {
  var uiProps = _ref.uiProps,
    overrideProps = _ref.overrideProps,
    showHidden = _ref.showHidden,
    resolvers = _objectWithoutProperties(_ref, _excluded),
    resolveComponent = useContext(ComponentMapContext),
    resolversWithOverrides = _objectSpread(_objectSpread({}, resolvers), {}, {
      resolveComponent: resolveComponent
    });
  return renderContentFromMetadataInternal(uiProps, overrideProps, resolversWithOverrides, showHidden);
};
MetadataContent.propTypes = metadataContentPropTypes, MetadataContent.defaultProps = {
  showHidden: !1
};